(function() {
  'use strict';
  
  
  function getCartDrawerInstance() {
    return window.cart || null;
  }
  
  // Function to get cart totals by product type
  function getCartTotals() {
    const cartItems = document.querySelectorAll('#cart-drawer [data-cart-item]');
    let foodShakeQty = 0;
    let completeProteinQty = 0;
    const itemCount = cartItems.length;
    
    cartItems.forEach((item) => {
      const quantityInput = item.querySelector('[data-quantity-field]');
      if (quantityInput) {
        const quantity = Number(quantityInput.value) || 0;
        
        if (item.hasAttribute('data-product-type')) {
          const productType = item.getAttribute('data-product-type');
          if (productType === 'food-shake') {
            foodShakeQty += quantity;
          } else if (productType === 'complete-protein') {
            completeProteinQty += quantity;
          }
        }
      }
    });
    
    return {
      foodShakeQty,
      completeProteinQty,
      itemCount,
      hasFoodShake: foodShakeQty > 0,
      hasCompleteProtein: completeProteinQty > 0,
      hasBoth: foodShakeQty > 0 && completeProteinQty > 0
    };
  }

  // Function to validate cart according to rules (async for mixed cart)
  async function validateCart() {
    const totals = getCartTotals();
    const isValid = totals.itemCount > 0;
    const errorMessage = isValid ? '' : 'Lägg till produkter i varukorgen.';

    return { isValid, errorMessage, itemCount: totals.itemCount };
  }
  
  // Function to update checkout button in drawer
  function updateCartDrawerCheckoutButton(isValid, errorMessage) {
    const checkoutButtons = document.querySelectorAll('.cart-drawer .btn-checkout, .cart-drawer .checkout-btn-fixed');
    
    checkoutButtons.forEach((checkoutButton) => {
      if (!checkoutButton) return;
      if (!isValid) {
        checkoutButton.disabled = true;
        checkoutButton.classList.add('is-disabled');
        checkoutButton.style.opacity = '0.6';
        checkoutButton.style.pointerEvents = 'none';
        checkoutButton.setAttribute('aria-disabled', 'true');
        checkoutButton.title = errorMessage || 'Cart requirements not met';
      } else {
        checkoutButton.disabled = false;
        checkoutButton.classList.remove('is-disabled');
        checkoutButton.style.opacity = '1';
        checkoutButton.style.pointerEvents = 'auto';
        checkoutButton.removeAttribute('aria-disabled');
        checkoutButton.title = '';
      }
    });
  }

  function updateMinimumWarningCard(isValid, errorMessage, itemCount) {
    const warningCards = document.querySelectorAll('[data-minimum-warning-card]');
    warningCards.forEach((card) => {
      const messageEl = card.querySelector('[data-minimum-warning-message]');
      const shouldShow = !isValid && itemCount > 0 && Boolean(errorMessage);
      card.classList.toggle('hidden', !shouldShow);
      card.style.display = shouldShow ? '' : 'none';
      if (messageEl) {
        messageEl.textContent = shouldShow ? errorMessage : '';
      }
    });
  }
  
  // Function to validate and update drawer
  async function validateCartDrawer() {
    const validation = await validateCart();
    updateCartDrawerCheckoutButton(validation.isValid, validation.errorMessage);
    updateMinimumWarningCard(validation.isValid, validation.errorMessage, validation.itemCount);
    return validation;
  }
  
  // Override CartDrawer getCart to use custom-api-cart-items
  // This ensures the custom design is maintained when cart updates
  function overrideCartDrawerGetCart() {
    const cartDrawerInstance = getCartDrawerInstance();
    const instanceSource = window.cart ? 'window.cart' : 'none';

    if (!cartDrawerInstance) {
      return false;
    }
      
      if (typeof cartDrawerInstance.getCart === 'function') {
        // Store original method
        const originalGetCart = cartDrawerInstance.getCart.bind(cartDrawerInstance);
        
        // Override the instance method
        cartDrawerInstance.getCart = function() {
          // Render cart drawer if it exists but it's not loaded yet
          if (this.cartDrawer && !this.isCartDrawerLoaded) {
            const alwaysOpen = false;
            if (typeof this.renderCartDrawer === 'function') {
              this.renderCartDrawer(alwaysOpen);
            }
          }

          // Use custom-api-cart-items instead of api-cart-items
          const fetchUrl = ((window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart') + '?section_id=custom-api-cart-items';
          
          fetch(fetchUrl)
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.text();
            })
            .then((response) => {
              const element = document.createElement('div');
              element.innerHTML = response;

              // Use the same selector as the original code
              const cleanResponse = element.querySelector('[data-api-content]');
              const headerInfo = element.querySelector('[data-api-header-info]');
              const footerInfo = element.querySelector('[data-api-footer-info]');
              const headerCount = headerInfo?.querySelector('[data-cart-items-count]')?.textContent || '';
              const cartTotalFormatted = headerInfo?.querySelector('[data-cart-total-formatted]')?.textContent || '';
              const totalDiscountsRaw = headerInfo?.querySelector('[data-total-discounts]')?.textContent || '0';
              const totalDiscountsFormatted = headerInfo?.querySelector('[data-total-discounts-formatted]')?.textContent || '';
              const discountCodeRaw = headerInfo?.querySelector('[data-discount-code-total]')?.textContent || '0';
              const discountCodeFormatted = headerInfo?.querySelector('[data-discount-code-formatted]')?.textContent || '';
              const lineDiscountRaw = headerInfo?.querySelector('[data-line-discount-total]')?.textContent || '0';
              const lineDiscountFormatted = headerInfo?.querySelector('[data-line-discount-formatted]')?.textContent || '';
              const subscriptionDiscountRaw = headerInfo?.querySelector('[data-subscription-discount]')?.textContent || '0';
              const subscriptionDiscountFormatted = headerInfo?.querySelector('[data-subscription-discount-formatted]')?.textContent || '';
              const originalSubtotalRaw = footerInfo?.querySelector('[data-original-subtotal]')?.textContent || '0';
              const originalSubtotalFormatted = footerInfo?.querySelector('[data-original-subtotal-formatted]')?.textContent || '';
              const finalTotalFormatted = footerInfo?.querySelector('[data-final-total-formatted]')?.textContent || '';
              window.customDrawerData = {
                itemCount: parseInt(headerCount || '0', 10),
                cartTotalFormatted: cartTotalFormatted,
                totalDiscountsRaw: parseInt(totalDiscountsRaw || '0', 10),
                totalDiscountsFormatted: totalDiscountsFormatted,
                discountCodeRaw: parseInt(discountCodeRaw || '0', 10),
                discountCodeFormatted: discountCodeFormatted,
                lineDiscountRaw: parseInt(lineDiscountRaw || '0', 10),
                lineDiscountFormatted: lineDiscountFormatted,
                subscriptionDiscountRaw: parseInt(subscriptionDiscountRaw || '0', 10),
                subscriptionDiscountFormatted: subscriptionDiscountFormatted,
                originalSubtotalRaw: parseInt(originalSubtotalRaw || '0', 10),
                originalSubtotalFormatted: originalSubtotalFormatted,
                finalTotalFormatted: finalTotalFormatted,
              };
              
              if (cleanResponse && typeof this.build === 'function') {
                try {
                this.build(cleanResponse);
                
                // Update extra section (subscription banner) if it exists in the response
                const extraSectionData = cleanResponse.querySelector('[data-api-extra-section]');
                if (extraSectionData) {
                  const drawerExtraSection = document.querySelector('.drawer-extra-section');
                  if (drawerExtraSection) {
                    drawerExtraSection.innerHTML = extraSectionData.innerHTML;
                    drawerExtraSection.style.display = '';
                    drawerExtraSection.classList.remove('hidden');
                  } else {
                    // If extra section doesn't exist, find where it should go and insert it
                    const cartItemsHolder = document.querySelector('#cartItemsHolder');
                    if (cartItemsHolder && cartItemsHolder.parentNode) {
                      const extraSection = document.createElement('div');
                      extraSection.className = 'drawer-extra-section';
                      extraSection.innerHTML = extraSectionData.innerHTML;
                      cartItemsHolder.parentNode.insertBefore(extraSection, cartItemsHolder.nextSibling);
                    }
                  }
                } else {
                  // If no extra section in response (cart is empty), hide it
                  const drawerExtraSection = document.querySelector('.drawer-extra-section');
                  if (drawerExtraSection) {
                    drawerExtraSection.style.display = 'none';
                    drawerExtraSection.classList.add('hidden');
                  }
                }
                } catch (error) {
                  // Silent error handling
                }
                
                // Dispatch event after build completes so custom update handler can run
                document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
              }
            })
            .catch((error) => {
              // Silent error handling
            });
        };
        return true;
      }
      
      // Also override updateCart to support selling_plan parameter
      if (typeof cartDrawerInstance.updateCart === 'function') {
        const originalUpdateCart = cartDrawerInstance.updateCart.bind(cartDrawerInstance);
        
        cartDrawerInstance.updateCart = function(updateData = {}, currentItem = null) {
          // If selling_plan is provided, handle it specially
          if (updateData.hasOwnProperty('selling_plan')) {
            
            if (currentItem !== null) {
              currentItem.classList.add('is-loading');
            }
            this.disableCartButtons();
            this.addLoadingClass();

            const newItem = this.cart.querySelector(`[data-item="${updateData.id}"]`) || currentItem;
            const lineIndex = newItem?.hasAttribute('data-item-index') ? parseInt(newItem.getAttribute('data-item-index')) : 0;

            if (lineIndex === 0) {
              this.enableCartButtons();
              this.removeLoadingClass();
              return;
            }

            // Fetch current cart to get item details and properties
            
            fetch(theme.routes.cart_url + '.js')
              .then((response) => response.json())
              .then((cart) => {
                // Find the item in the cart (line index is 1-based)
                const item = cart.items[lineIndex - 1];
                
                if (!item) {
                  this.enableCartButtons();
                  this.removeLoadingClass();
                  return;
                }
                
                // Step 1: Remove current item
                return fetch(theme.routes.cart_change_url, {
                  method: 'post',
                  headers: {'Content-Type': 'application/json', Accept: 'application/json'},
                  body: JSON.stringify({ line: lineIndex, quantity: 0 }),
                })
                  .then((response) => response.text())
                  .then((state) => {
                    const parsedState = JSON.parse(state);
                    
                    if (parsedState.errors) {
                      throw new Error(parsedState.errors);
                    }
                    
                    // Step 2: Re-add with new selling plan and preserved properties
                    const addData = {
                      items: [{
                        id: item.variant_id,
                        quantity: item.quantity,
                        properties: item.properties || {}
                      }]
                    };
                    
                    // Add selling_plan only if not null
                    if (updateData.selling_plan !== null) {
                      addData.items[0].selling_plan = updateData.selling_plan;
                    }
                    
                    return fetch(theme.routes.cart_add_url || '/cart/add.js', {
                      method: 'post',
                      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
                      body: JSON.stringify(addData),
                    });
                  })
                  .then((response) => response.text())
                  .then((state) => {
                    const parsedState = JSON.parse(state);
                    
                    if (parsedState.errors || parsedState.status) {
                      throw new Error(parsedState.message || 'Re-add failed');
                    }
                    
                    this.getCart();
                  });
              })
              .catch((error) => {
                this.enableCartButtons();
                this.removeLoadingClass();
              });
          } else {
            // Use original method for regular updates
            originalUpdateCart(updateData, currentItem);
          }
        };
      }
    return false;
  }
  
  // Also try to override before CartDrawer is instantiated
  function overrideCartDrawerPrototype() {
    // This is a backup - try to find CartDrawer class in the theme object
    // Most themes store the class somewhere accessible
    if (window.theme && window.theme.CartDrawer) {
      const CartDrawerClass = window.theme.CartDrawer;
      const originalGetCart = CartDrawerClass.prototype.getCart;
      
      if (originalGetCart) {
        CartDrawerClass.prototype.getCart = function() {
          // Render cart drawer if it exists but it's not loaded yet
          if (this.cartDrawer && !this.isCartDrawerLoaded) {
            const alwaysOpen = false;
            if (typeof this.renderCartDrawer === 'function') {
              this.renderCartDrawer(alwaysOpen);
            }
          }

          // Use custom-api-cart-items instead of api-cart-items
          const fetchUrl = (theme.routes.cart_url || '/cart') + '?section_id=custom-api-cart-items';
          
          fetch(fetchUrl)
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.text();
            })
            .then((response) => {
              const element = document.createElement('div');
              element.innerHTML = response;

              const cleanResponse = element.querySelector('[data-api-content]');
              if (cleanResponse && typeof this.build === 'function') {
                this.build(cleanResponse);
                
                // Update extra section (subscription banner) if it exists in the response
                const extraSectionData = cleanResponse.querySelector('[data-api-extra-section]');
                if (extraSectionData) {
                  const drawerExtraSection = document.querySelector('.drawer-extra-section');
                  if (drawerExtraSection) {
                    drawerExtraSection.innerHTML = extraSectionData.innerHTML;
                  } else {
                    // If extra section doesn't exist, find where it should go and insert it
                    const cartItemsHolder = document.querySelector('#cartItemsHolder');
                    if (cartItemsHolder && cartItemsHolder.parentNode) {
                      const extraSection = document.createElement('div');
                      extraSection.className = 'drawer-extra-section';
                      extraSection.innerHTML = extraSectionData.innerHTML;
                      cartItemsHolder.parentNode.insertBefore(extraSection, cartItemsHolder.nextSibling);
                    }
                  }
                } else {
                  // If no extra section in response and cart is empty, hide it
                  const drawerExtraSection = document.querySelector('.drawer-extra-section');
                  if (drawerExtraSection) {
                    drawerExtraSection.style.display = 'none';
                  }
                }
                
                // Dispatch event after build completes
                document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
              }
            })
            .catch((error) => {
              // Silent error handling
            });
        };
        return true;
      }
    }
    
    return false;
  }

  // Initialize when drawer is opened or cart is updated
  // Try to override immediately and on multiple events
  function initializeOverrides() {
    // Try prototype override first (before instantiation)
    const prototypeResult = overrideCartDrawerPrototype();
    
    // Try instance override
    const instanceResult = overrideCartDrawerGetCart();
  }
  
  // Run immediately if theme is already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeOverrides);
  } else {
    initializeOverrides();
  }
  
  // Also try multiple times with delays to catch late-loading instances
  setTimeout(initializeOverrides, 100);
  setTimeout(initializeOverrides, 500);
  setTimeout(initializeOverrides, 1000);
  setTimeout(initializeOverrides, 2000);
  
  // Listen for theme initialization events
  document.addEventListener('DOMContentLoaded', function() {
    // Override getCart method to use custom-api-cart-items
    initializeOverrides();
    
    // Listen for cart updates
    document.addEventListener('theme:cart:update', function() {
      setTimeout(validateCartDrawer, 100);
    });
    
    // Listen for quantity changes
    document.addEventListener('input', function(e) {
      if (e.target.matches('[data-quantity-field]')) {
        setTimeout(validateCartDrawer, 10);
      }
    });
    
    // Validate on drawer open
    const drawerToggle = document.querySelector('[data-cart-drawer-toggle]');
    if (drawerToggle) {
      drawerToggle.addEventListener('click', function() {
        setTimeout(validateCartDrawer, 200);
      });
    }
    
    // Intercept checkout in drawer
    const drawerForm = document.querySelector('#cartDrawerCheckoutForm');
    if (drawerForm) {
      drawerForm.addEventListener('submit', async function(e) {
        const validation = await validateCart();
        if (!validation.isValid) {
          e.preventDefault();
          alert(validation.errorMessage);
          return false;
        }
      });
    }
    
    // Initial validation
    setTimeout(validateCartDrawer, 500);
    
    // Periodic validation
    setInterval(validateCartDrawer, 1000);
    
    // Handle selling plan changes - call updateCart directly
    function setupSellingPlanListener() {
      document.addEventListener('change', function(e) {
        if (e.target.matches('.selling-plan-select')) {
          const select = e.target;
          const productItem = select.closest('[data-cart-item]');
          const lineItemKey = select.getAttribute('data-line-item-key');
          const sellingPlanId = select.value;
          
          const cartDrawerInstance = getCartDrawerInstance();
          
          if (!lineItemKey || !productItem) {
            return;
          }
          
          // Call updateCart directly on the CartDrawer instance
          if (cartDrawerInstance && typeof cartDrawerInstance.updateCart === 'function') {
            cartDrawerInstance.updateCart(
              {
                id: lineItemKey,
                selling_plan: sellingPlanId ? parseInt(sellingPlanId) : null
              },
              productItem
            );
          } else {
            // Retry initialization
            initializeOverrides();
            
            // Retry after a short delay
            setTimeout(function() {
              const retryCartDrawer = getCartDrawerInstance();
              if (retryCartDrawer && typeof retryCartDrawer.updateCart === 'function') {
                retryCartDrawer.updateCart(
                  {
                    id: lineItemKey,
                    selling_plan: sellingPlanId ? parseInt(sellingPlanId) : null
                  },
                  productItem
                );
              } else {
                // Manual fallback: fetch cart, remove item, re-add
                handleSellingPlanChangeManual(lineItemKey, sellingPlanId, select);
              }
            }, 500);
          }
        }
      });
    }
    
    // Manual fallback for selling plan changes
    function handleSellingPlanChangeManual(lineItemKey, sellingPlanId, select) {
      // Get line index from the product item
      const productItem = select.closest('[data-cart-item]');
      const lineIndex = productItem?.getAttribute('data-item-index');
      
      if (!lineIndex) {
        alert('Kunde inte uppdatera. Försök igen.');
        return;
      }
      
      // Fetch current cart
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const item = cart.items[parseInt(lineIndex) - 1];
          
          // Remove item
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: parseInt(lineIndex), quantity: 0 })
          })
            .then(r => r.json())
            .then(() => {
              // Re-add with new selling plan
              const addData = {
                items: [{
                  id: item.variant_id,
                  quantity: item.quantity,
                  properties: item.properties || {}
                }]
              };
              
              if (sellingPlanId) {
                addData.items[0].selling_plan = parseInt(sellingPlanId);
              }
              
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(addData)
              });
            })
            .then(r => r.json())
            .then(() => {
              // Refresh drawer
              const cartDrawerInstance = getCartDrawerInstance();
              if (cartDrawerInstance && typeof cartDrawerInstance.getCart === 'function') {
                cartDrawerInstance.getCart();
              } else {
                window.location.reload();
              }
            });
        })
        .catch(error => {
          alert('Kunde inte uppdatera. Försök igen.');
        });
    }
    
    // Clear cart functionality (fast path)
    function initClearCart() {
      document.addEventListener('click', async (e) => {
        const clearBtn = e.target.closest('[data-clear-cart]');
        if (!clearBtn) return;
        e.preventDefault();

        const labelEl = clearBtn.querySelector('span');
        const originalLabel = labelEl ? labelEl.textContent : '';
        clearBtn.disabled = true;
        if (labelEl) {
          labelEl.textContent = 'Rensar...';
        }

        try {
          const response = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
          });

          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.description || 'Failed to clear cart');
          }

          // Refresh the cart drawer once after clear completes.
          const cartDrawerInstance = getCartDrawerInstance();
          if (cartDrawerInstance && typeof cartDrawerInstance.getCart === 'function') {
            cartDrawerInstance.getCart();
          } else {
            window.location.reload();
          }
        } catch (error) {
          alert('Kunde inte tömma varukorgen. Försök igen.');
        } finally {
          clearBtn.disabled = false;
          if (labelEl) {
            labelEl.textContent = originalLabel;
          }
        }
      });
    }
    
    // Initialize header functionality
    initClearCart();
    
    // Initialize upsell functionality
    setupSellingPlanListener();
  });
  
})();
